import { useEffect, useMemo, useState, useRef, useContext } from "react";
import { callautopopulate } from "../../../services/callautopop";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls"
import _ from "underscore";
import { useCommon } from '../../../Hooks/Features/Pocker/useCommon';
import { useCommon as useCommonPermi } from '../../../Hooks/Common/useCommon';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { dateConvert, hourStringtoHours, secondsToHours } from "../../../utils/Helper";
import { Dropdown } from "primereact/dropdown";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCalender } from "../Dashboard/useCalender";
import { useAgileMatrixHeatmap } from "../TalentMatrix/useAgileMatrixHeatmap";
import { useReviewing } from "./useReviewing";
import { SkeletonContainer } from "../../../components/Loader/Loader";

export const useMyBucket = ({ fromTaskList }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const { showTimesheet, setShowTimesheet } = useCalender()
    const tagRef = useRef(null);
    const [rowData, setRowData] = useState([]);
    const [loggedInUser, setLoggedInUser] = useState();
    const [loader, setLoader] = useState(false);
    const { getEpicList, getSubProject } = useCommon();
    const { getValuePermission } = useCommonPermi();
    const [options, setOptions] = useState({ project: [], epicList: [] });
    const [filterValues, setFilterValues] = useState({ projects: [], epic: [], issueKey: '', date: null, });
    const [clickedRowTaskId, setClickedRowTaskId] = useState(null);
    const [statusOptionsByRow, setStatusOptionsByRow] = useState({});
    const [selectedStatusByRow, setSelectedStatusByRow] = useState({});
    const [selectedTab, setSelectedTab] = useState("my_assigned");
    const { colorCodes, getColorKey } = useAgileMatrixHeatmap({ filterValues, setFilterValues, fromOther: true });
    const [tooltip, setTooltip] = useState({ currentBid: {} });
    const [workspaceRowData, setWorkspaceRowData] = useState([])
    const [selectedData, setSelectedData] = useState([]);
    const [taskLoader, setTaskLoader] = useState({});
    const [taskDetailsPopup, setTaskDetailsPopup] = useState({ show: false })
    const [popupValue, setPopupValue] = useState({
        file: [],
        show: false
    });

    const columns = {
        myAssigned: [
            {
                key: "issue_key",
                label: "Task ID",
                headerStyle: { textAlign: "center" },
                style: { width: "8%", textAlign: "center" },
                render: (row) => {
                    return <>
                        <div className="fw-semibold d-flex justify-content-center align-items-center">
                            <img src={row?.issue_type_image_url} className='new-game-img' alt='' width={20} height={20} />
                            <div className="c-pointer" onClick={() => setTaskDetailsPopup((prev) => ({ ...prev, show: true, data: row }))}>{row?.issue_key}</div>
                        </div>
                    </>

                }
            },
            {
                key: 'issue_summary',
                label: 'Task',
                style: { width: "31%" },
                render: (row) => {
                    return <p title={row?.issue_summary} className=" text-truncate">{row?.issue_summary}</p>
                }
            },
            {
                key: 'features_issue_summary',
                label: 'Feature',
                style: { width: '15%' },
                render: (row) => {
                    return (
                        <p className=" text-truncate" title={row?.features_issue_summary}> {row.features_issue_summary || '-'}</p>
                    );
                }
            },
            {
                key: 'status',
                label: 'Status',
                style: { width: "8%", textAlign: "center" },
                sort: false,
                render: (row) => {
                    if (!row?.issue_id) return <span>-</span>;
                    const rowKey = row?.issue_id;
                    const rowOptions = statusOptionsByRow[rowKey] || [];
                    const rowSelected = selectedStatusByRow[rowKey] || { id: `${row?.issue_id}-current`, name: row?.status_name };
                    const isInProgress = row?.status_name?.toLowerCase().includes('progress');
                    const cellBgColor = isInProgress ? "#579dff" : "transparent";
                    return (
                        taskLoader?.[row?.issue_id] ?
                            <div style={{ height: "25px" }}><SkeletonContainer /></div> :
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'stretch', width: '100%', height: '100%', backgroundColor: cellBgColor, }} title={row?.status_name?.trim() === "Code Review" ? `Reviewer: ${row?.reviewer_user_display_name}` : ""} >
                                <Dropdown
                                    className="tast-list-dd"
                                    value={rowSelected}
                                    options={rowOptions}
                                    style={{ width: '100%', height: '100%', backgroundColor: 'transparent', fontWeight: isInProgress ? "500" : "normal", border: 'none', }}
                                    onChange={(e) => {
                                        const newStatus = e?.value
                                        if (newStatus?.name?.trim() === "Code Review") {
                                            getProjectUser(row?.project_id)
                                            setPopupValue({ show: true, file: [], row, newStatus, fileInput: ["qa-web", "qa-api", "qa-app"]?.includes(row?.issue_type_name?.toLowerCase()) })
                                            return;
                                        }
                                        handleStatusChange(row, newStatus)
                                    }}
                                    optionLabel="name"
                                    placeholder={row?.status_name || 'Select Status'}
                                    onClick={() => !rowOptions.length && loadStatusOptions(row)}
                                />
                            </div>
                    );
                },
            },
            {
                key: 'estimatetime',
                label: 'Bidded Hours',
                style: { width: '5%', textAlign: "center", },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    const hour = row?.estimatetime ? row?.estimatetime * 3600 : 0
                    return (
                        <>
                            {row?.is_direct_assigned ?
                                <Dropdown
                                    className="input-dd w100 m-0"
                                    filter filterInputAutoFocus
                                    value={hour}
                                    placeholder="Estimate"
                                    options={options?.bidOption || []}
                                    optionLabel="label"
                                    onChange={(e) => { handleEstimateSave(row, e.target.value) }} />
                                :
                                <div>{row?.estimatetime ? row?.estimatetime + "h" : "-"}</div>}
                        </>
                    )
                }
            },
            {
                key: 'spent_time',
                label: 'Worked Hours',
                style: { width: '5%', textAlign: "center" },
                headerStyle: { textAlign: "center" },
            },
            {
                key: 'time_spent_percentage',
                label: 'Bid / Actual',
                style: { width: '5%', padding: 0 },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    const data = row?.data?.time_spent_percentage || row?.time_spent_percentage || 0;
                    if (!data) return;
                    const bgColor = data > 105 ? '#ff8a8a' :
                        (data >= 95 && data <= 105) ? '#a5d6a7' :
                            '#ffcc80';
                    return (
                        <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: bgColor, minWidth: '50px', height: "30px" }}>
                            {data}%
                        </div>
                    );
                },
            },
            {
                key: 'assigned',
                label: 'Assigned',
                style: { textAlign: "center", width: "7%" },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    if (!row?.issue_id) return null;
                    return (
                        <div className="text-truncate" title={row?.declared_datetime ? dateConvert(row?.declared_datetime, "date-time-months") : ""}>
                            {row?.declared_datetime ? dateConvert(row?.declared_datetime, "date-time-months") : "-"}
                        </div>
                    )
                }
            },
            {
                key: 'start',
                label: 'Actual Start',
                style: { textAlign: "center", width: "7%" },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    if (!row?.issue_id) return null;
                    return (
                        <div className="text-truncate" title={row?.actual_start ? dateConvert(row?.actual_start, "date-time-months") : ""}>
                            {row?.actual_start ? dateConvert(row?.actual_start, "date-time-months") : "-"}
                        </div>
                    )
                }
            },
            {
                key: 'end',
                label: 'Actual End',
                style: { textAlign: "center", width: "7%" },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    if (!row?.issue_id) return null;
                    return (
                        <div className="text-truncate" title={row?.actual_end ? dateConvert(row?.actual_end, "date-time-months") : ""}>
                            {row?.actual_end ? dateConvert(row?.actual_end, "date-time-months") : "-"}
                        </div>
                    )
                }
            },
            {
                key: 'actions',
                label: '',
                style: { width: '2%' },
                sort: false,
                render: (row) => (
                    <div className="d-flex align-items-center justify-content-center py-2 gap-2">
                        <>
                            <FontAwesomeIcon
                                icon={faClock}
                                className="c-pointer"
                                onClick={() => { setClickedRowTaskId(row?.issue_id); setShowTimesheet(true); }}
                                title="Log Timesheet"
                            />
                        </>
                    </div>
                )
            }
        ],
        workspace: [
            {
                key: "",
                label: "",
                checkbox: true,
                headerStyle: { textAlign: "center" },
                style: { width: "3%", textAlign: "center" },
                render: (row, isAll) => {
                    const allData = _.pluck(workspaceRowData, "children")?.flat();
                    let isChecked = isAll === "all" ? ((_.isEqual(_.sortBy(allData, "issue_key"), _.sortBy(selectedData, "issue_key")) && !_.isEmpty(allData)) ? true : false) : (!_.isEmpty(_.findWhere(selectedData, { issue_id: row?.issue_id })));
                    return (
                        <div className="d-flex justify-content-center">
                            <input
                                type="checkbox"
                                className="input-dd"
                                checked={isChecked}
                                onChange={(e) => handleTaskSelection(row, isAll, e.target?.checked)}
                            />
                        </div>
                    )
                }
            },
            {
                key: "issue_key",
                label: "Task ID",
                headerStyle: { textAlign: "center" },
                style: { width: "8%", textAlign: "center" },
                render: (row) => {
                    return <>
                        <div className="fw-semibold d-flex justify-content-center align-items-center">
                            <img src={row?.issue_type_image_url} className='new-game-img' alt='' width={20} height={20} />
                            <a className="c-pointer" href={row?.issue_url} target="_blank">{row?.issue_key}</a>
                        </div>
                    </>

                }
            },
            {
                key: 'issue_summary',
                label: 'Task',
                style: { width: "31%", flex: 1 },
                render: (row) => {
                    return <div title={row?.issue_summary} className=" text-truncate">{row?.issue_summary}</div>
                }
            },
            {
                key: 'estimatetime',
                label: 'Current Bid',
                style: { width: '10%', textAlign: "center" },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    const [min, max] = row?.actual_range ? row?.actual_range?.split("-")?.map(item => item?.trim()) : [];
                    const minHours = hourStringtoHours(min);
                    const maxHours = hourStringtoHours(max);
                    const avg = ((minHours + maxHours) / 2) || 0;
                    const bidHours = row?.bid_seconds / 3600;
                    const percentDiff = avg ? Math.ceil((bidHours - avg) * 100 / avg) : 0;
                    let key = "";
                    let icon = "";
                    let type = "";
                    if (bidHours >= minHours && bidHours <= maxHours) {
                        key = "success";
                        icon = "";
                        type = "Accurate";
                    } else if (bidHours > maxHours) {
                        key = "danger";
                        icon = "up";
                        type = "Over";
                    } else if (bidHours < minHours) {
                        key = "warning";
                        icon = "down";
                        type = "Lower";
                    }
                    return (
                        <div className={`text-truncate fw-semibold d-flex align-items-center gap-2 justify-content-center ${avg ? "current-bid-tooltip" : ""}`} style={{ color: key === "warning" ? "#d97706" : colorCodes[key]?.color }} onMouseEnter={() => setTooltip((prev) => ({ ...prev, currentBid: { percent: percentDiff, avg, type } }))}>
                            <div>{row?.bid_info || ""}</div>
                            <FontAwesomeIcon icon={`fa-solid fa-arrow-trend-${icon}`} className={icon ? "visible" : "invisible"} />

                        </div>
                    );
                }
            },
            {
                key: 'actual_range',
                label: 'My History',
                style: { width: '10%', textAlign: "center" },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    return (
                        <div className="fw-semibold text-truncate"> {row?.actual_range || '-'}</div>
                    );
                }
            },
            {
                key: 'bid_accuracy',
                label: 'My Accuracy',
                style: { width: '7%', textAlign: "center" },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    const colorCode = row?.bid_accuracy ? colorCodes?.[getColorKey(row?.bid_accuracy)] : {}
                    return (
                        <div className=" text-truncate p-2">
                            <span className="px-2 fw-semibold" style={{ backgroundColor: colorCode?.background, border: `1px solid ${colorCode?.border}`, color: colorCode?.color }}>{row.bid_accuracy ? parseFloat(row.bid_accuracy?.toFixed(2)) + "%" : "-"}</span>
                        </div>
                    );
                }
            },
            {
                key: 'pick',
                label: 'Pick',
                style: { width: '5%', textAlign: "center" },
                headerStyle: { textAlign: "center" },
                render: (row) => {
                    return (
                        <div className="d-flex justify-content-center align-items-center" onClick={() => handlePick(row)}>
                            <FontAwesomeIcon icon="fa-solid fa-plus" className="rounded c-pointer text-primary pick-task-btn p-2" title="Pick Task" style={{ width: "15px", height: "15px" }} />
                        </div>
                    );
                }
            },
        ]
    };

    useEffect(() => {
        callautopopulate("projects", "user_info", "bid_seconds").then(res => {
            res?.bid_seconds?.forEach(item => {
                item.label = secondsToHours(item.bid_seconds);
                item.value = item?.bid_seconds
            });
            setOptions((prev) => ({ ...prev, bidOption: res?.bid_seconds, project: res?.projects?.sort((a, b) => a.project_name?.localeCompare(b.project_name)) }))
            setLoggedInUser(res?.user_info?.[0]?.user_code);
        });
    }, []);

    useEffect(() => {
        if (loggedInUser && filterValues.apiCall && !fromTaskList) {
            handleApiCall();
            setSelectedData([]);
        }
    }, [loggedInUser, filterValues.apiCall, selectedTab]);

    useEffect(() => {
        setStatusOptionsByRow({});
        setSelectedStatusByRow({});
    }, [rowData]);


    const getProjectUser = async (id) => {
        const data = await getSubProject(id, ["is_project_users"], loggedInUser);
        if (data) {
            setOptions((prev) => ({ ...prev, projectUsers: _.sortBy(data?.projectUsers, "user_display_name") || [] }))
        }
    }

    const handleEstimateSave = async (rowdata, val) => {
        try {
            const payload = {
                "issue_key": rowdata?.issue_key,
                "original_estimate": val || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTDIRECTISSUEESTIMATE"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setRowData(prevData => {
                    return prevData.map(parent => ({
                        ...parent,
                        children: parent.children.map(child =>
                            child?.issue_id === rowdata?.issue_id ? { ...child, ...{ estimatetime: val / 3600 } } : child
                        )
                    }));
                });
            } else {
                showError("error", res.body.message);
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const getData = async (row) => {
        try {
            !row && setLoader(true);
            const payload = {
                project_ids: _.pluck(filterValues.projects, "project_id").toString() || "",
                epic_ids: filterValues?.epic?.toString() || "",
                requested_user_code: loggedInUser || 0,
                issue_ids: filterValues.issueKey || "",
                declared_datetime: filterValues.date ? dateConvert(filterValues.date, "iso-string") : ""
            };
            const res = await services.getInvokeRemote("POST", Urls("PGETMYBUCKETDETAIL"), payload);
            if (res?.body?.data?.mybucket_detail) {
                setRowData([{
                    id: 'all',
                    title: "",
                    children: _.sortBy(res?.body?.data?.mybucket_detail, "issue_key")
                }]);
                if (row) {
                    const findTask = _.findWhere(res?.body?.data?.mybucket_detail, { issue_id: row?.issue_id });
                    const findOpt = _.findWhere(statusOptionsByRow?.[row?.issue_id], { name: findTask?.status_name });
                    setSelectedStatusByRow((prev) => ({ ...prev, [row?.issue_id]: findOpt }));
                }
            } else {
                setRowData([]);
            }
        } catch (error) {
            console.error("error: ", error);
            setRowData([]);
        } finally {
            setLoader(false);
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            row && setTaskLoader((prev) => ({ ...prev, [row?.issue_id]: false }));
        }
    };

    useEffect(() => {
        if (filterValues.projects?.length > 0) {
            getEpicList(filterValues.projects, setOptions);
        } else {
            setOptions(prev => ({ ...prev, epicList: [] }));
        }
    }, [filterValues.projects]);

    const loadStatusOptions = async (row) => {
        const rowKey = row.issue_id;
        try {
            const payload = {
                issueId: row?.issue_id
            }
            const res = await services.getInvokeRemote("POST", Urls("IMPORTTRANSITIONSFORISSUE"), payload);
            const options = _.filter(res?.body?.data?.transitions || [], opt => opt.name?.trim());
            const currentStatus = { id: `${rowKey}-current`, name: row.status_name };
            const finalOptions = _.find(options, opt => opt.name === row.status_name)
                ? options
                : [currentStatus, ...options];
            setStatusOptionsByRow(prev => ({ ...prev, [rowKey]: finalOptions }));
            setSelectedStatusByRow(prev => ({ ...prev, [rowKey]: _.find(finalOptions, opt => opt.name === row.status_name) || currentStatus }));
        } catch (error) {
            const fallback = [{ id: `${rowKey}-current`, name: row.status_name }];
            setStatusOptionsByRow(prev => ({ ...prev, [rowKey]: fallback }));
            setSelectedStatusByRow(prev => ({ ...prev, [rowKey]: fallback[0] }));
        }
    };

    const handleStatusChange = async (row, newStatus, isOuter) => {
        if (row?.is_direct_assigned && row?.estimatetime !== undefined && Number(row?.estimatetime) <= 0) {
            showInfo("Info", "Please select an estimate before changing the task status.");
            return;
        }
        const rowKey = row?.issue_id;
        try {
            setTaskLoader((prev) => ({ ...prev, [row?.issue_id]: true }));
            const payload = {
                IssueId: row?.issue_id,
                DestinationStage: newStatus?.name
            }
            setSelectedStatusByRow(prev => ({ ...prev, [rowKey]: newStatus }));
            const res = await services.getInvokeRemote("POST", Urls("UPDATEISSUESTAGE"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                // setLoader(true);
                if (isOuter) {
                    return true;
                } else {
                    setTimeout(() => {
                        getData(row);
                    }, 5000);
                }

            } else {
                showError("Error", res?.body?.message);
                if (isOuter) return false;
                setSelectedStatusByRow(prev => ({ ...prev, [rowKey]: { id: `${row.issue_id}-current`, name: row.status_name } }));
                setTaskLoader((prev) => ({ ...prev, [row?.issue_id]: false }));
            }
        } catch (error) {
            console.error("Error:", error);
            if (isOuter) return false;
            setSelectedStatusByRow(prev => ({ ...prev, [rowKey]: { id: `${row.issue_id}-current`, name: row.status_name } }));
            setTaskLoader((prev) => ({ ...prev, [row?.issue_id]: false }));
        }
    };

    // Add reviwer for code review
    const updateReviewer = async (isOuter) => {
        try {
            setPopupValue((prev) => ({ ...prev, loader: true }))
            if (!popupValue?.userCode) {
                showInfo("Info", "Please select a reviewer.");
                return;
            }
            const payload = {
                "IssueId": popupValue?.row?.issue_id,
                "assigneeUserCode": popupValue?.userCode,
            }
            const res = await services?.getInvokeRemote("POST", Urls("UPDATEJIRAREVIEWER"), payload)
            if (!res?.body?.error_status) {
                if (popupValue?.file?.length > 0 && popupValue?.fileInput) {
                    setPopupValue(prev => ({ ...prev, uploadLoader: true }));
                    uploadFiles(isOuter);
                } else {
                    handleStatusChange(popupValue?.row, popupValue?.newStatus, isOuter)
                    setPopupValue({ show: false, file: [] })
                }

            } else {
                showError("Error", res?.body?.message);
                setPopupValue((prev) => ({ ...prev, loader: false, uploadLoader: false }))
            }
        } catch (error) {
            setPopupValue((prev) => ({ ...prev, loader: false, uploadLoader: false  }))
            console.error("error:::", error)
        }
    }


    const uploadFiles = async (isOuter) => {
        const API_LIMIT_BYTES = 50 * 1024 * 1024;
        const rawFiles = popupValue?.file || [];
        const issueKey = popupValue?.row?.issue_key;
        const getActualSize = (base64String) => {
            if (!base64String) return 0;
            return (base64String.length * 3) / 4;
        };
        const oversizedFiles = rawFiles.filter(item =>
            item.base64 && getActualSize(item.base64) > API_LIMIT_BYTES
        );
        if (oversizedFiles.length > 0) {
            const fileNames = oversizedFiles.map(f => f.file?.name).join(", ");
            showError("Error", `Files are too large (limit 50MB after encoding): ${fileNames}`);
            setPopupValue(prev => ({ ...prev, uploadLoader: false }));
            return;
        }
        const allAttachments = rawFiles
            .filter(file => file.base64 !== undefined)
            .map(item => ({
                FileBytes: item.base64,
                FileName: item?.file?.name || "",
                actualSize: getActualSize(item.base64)
            }));
        const chunks = [];
        let currentBatch = [];
        let currentBatchSize = 0;

        allAttachments.forEach((file) => {
            if (currentBatchSize + file.actualSize > API_LIMIT_BYTES && currentBatch.length > 0) {
                chunks.push(currentBatch);
                currentBatch = [];
                currentBatchSize = 0;
            }
            currentBatch.push(file);
            currentBatchSize += file.actualSize;
        });
        if (currentBatch.length > 0) chunks.push(currentBatch);
        let finalResponse = null;
        let hasError = false;

        try {
            for (const batch of chunks) {
                const cleanBatch = batch.map(({ actualSize, ...rest }) => rest);
                finalResponse = await UploadJiraAttachment({ issueKey, attachments: cleanBatch }, isOuter);
                if (finalResponse?.body?.error_status) {
                    hasError = true;
                    break;
                }
            }

            if (!hasError && finalResponse) {

                const res = await handleStatusChange(popupValue?.row, popupValue?.newStatus, isOuter);
                if (res) {
                    setTimeout(() => { getData(); }, 5000);
                    setPopupValue({ show: false, file: [], loader: false });
                }
            } else {
                showError("Error", finalResponse?.body?.message || "Upload failed");
                setPopupValue(prev => ({ ...prev, loader: false }));
            }
        } catch (err) {
            setPopupValue(prev => ({ ...prev, uploadLoader: false }));
            showError("Error", "An unexpected error occurred.");
            setPopupValue(prev => ({ ...prev, loader: false }));
        }
    };


    //  for file attachments in code review if type (qa-app/web/api)
    const UploadJiraAttachment = async (payload, isOuter) => {
        try {
            const res = await services.getInvokeRemote("POST", Urls("UPLOADJIRAATTACHMENT"), payload)
            return res
        } catch (error) {
            console.error("error:::", error)
            setPopupValue((prev) => ({ ...prev, loader: false }))
        }

    }

    const handleTaskSelection = (row, isAll, checkedValue) => {
        if (isAll === "all") {
            const allData = _.pluck(workspaceRowData, "children")?.flat()
            setSelectedData(checkedValue ? allData : []);
        } else {
            if (!_.isEmpty(_.findWhere(selectedData, { issue_id: row?.issue_id }))) {
                setSelectedData(_.filter(selectedData, item => item?.issue_id !== row?.issue_id));
            } else {
                setSelectedData([...selectedData, row]);
            }
        }
    }

    const getWorkspaceData = async () => {
        try {
            setLoader(true);
            const payload = {
                project_ids: _.pluck(filterValues.projects, "project_id").toString() || "",
                issue_keys: filterValues.issueKey || "",
                epic_ids: filterValues?.epic?.toString() || "",
            }
            const res = await services.getInvokeRemote("POST", Urls("GETBUCKETWORKSPACEDETAIL"), payload);
            if (!res?.body?.error_status) {
                const data = res?.body?.data?.bucket_workspace_details;
                let grouped = {};
                _.sortBy(data, "issue_key")?.forEach(issue => {
                    const featureKey = issue?.features_issue_summary;
                    if (featureKey) {
                        if (!grouped[featureKey]) {
                            grouped[featureKey] = {
                                id: featureKey,
                                title: issue?.features_issue_summary || featureKey,
                                children: []
                            };
                        }
                        grouped[featureKey].children.push(issue);
                    }
                });
                setWorkspaceRowData(Object.values(grouped));
            }
            setLoader(false);
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const handlePick = async (row) => {
        try {
            if (!row && _.isEmpty(selectedData)) {
                showInfo("Info", "No tasks selected");
                return;
            }
            let tvp = [];
            (row ? [row] : selectedData)?.forEach(item => {
                tvp.push({
                    issue_id: item?.issue_id || 0,
                    winner_user_code: item?.winner_user_code || 0,
                    alloted_user_code: loggedInUser || 0,
                    product_code: item?.product_code || 0
                })
            })
            const payload = {
                "is_declared": true,
                "tvp_bucket_result_declare": tvp,
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTBUCKETRESULTDECLARE"), payload)
            if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 ||
                res.body.StatusCode === 500) {
                showError("Error", res.body.errorMessage);
            } else {
                showSuccess("Success", res.body.message);
                getWorkspaceData();
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleApiCall = () => {
        selectedTab === "my_assigned" ? getData() : getWorkspaceData();
    }

    return useMemo(() => ({
        tagRef, options, showTimesheet, rowData, columns, loader, filterValues, setFilterValues, clickedRowTaskId, setShowTimesheet, popupValue, setPopupValue, updateReviewer, handleStatusChange, statusOptionsByRow, selectedStatusByRow, setSelectedStatusByRow, getProjectUser, loadStatusOptions, selectedTab, setSelectedTab, workspaceRowData, tooltip, handlePick, handleApiCall, taskDetailsPopup, setTaskDetailsPopup, setStatusOptionsByRow
    }), [tagRef, options, showTimesheet, rowData, columns, loader, filterValues, setFilterValues, clickedRowTaskId, setShowTimesheet, popupValue, setPopupValue, updateReviewer, handleStatusChange, statusOptionsByRow, selectedStatusByRow, setSelectedStatusByRow, getProjectUser, loadStatusOptions, selectedTab, setSelectedTab, workspaceRowData, tooltip, handlePick, handleApiCall, taskDetailsPopup, setTaskDetailsPopup, setStatusOptionsByRow
    ]);
};






